import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=8955206a&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=8955206a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955206a",
  null
  
)

export default component.exports